import { Plan } from '@/app/(intakeFormV2)/intake-v2/types';
import { Text } from '@/components/ui/Text';
import { MarketingCard } from '../../common/PlanDetails';

export const MembershipMarketingBlock = ({
  plans,
  pediatrics,
  callback,
}: {
  plans: Plan[];
  pediatrics: boolean;
  callback: (plan: Plan) => void;
}) => {
  const unique = plans ? [...new Set(plans)] : [];

  if (!unique.length) return null;

  return (
    <div>
      {!unique.includes('Platinum') && (
        <div className='flex flex-col items-center gap-[40px] px-[16px] py-[64px]'>
          <Text variant='h1-serif' className='text-center'>
            Unlock Our Most Comprehensive Plan
          </Text>
          <div>
            <MarketingCard plan='Platinum' callback={callback} />
          </div>
        </div>
      )}
      {pediatrics && !unique.includes('Pediatrics') && (
        <div className='flex flex-col items-center gap-[40px] p-[30px] py-[64px]'>
          <Text variant='h1-serif' className='text-center'>
            Get complete concierge care for your child
          </Text>
          <div>
            <MarketingCard plan='Pediatrics' callback={callback} />
          </div>
        </div>
      )}
    </div>
  );
};
